import axiosInstance from "../../../../../axiosInstance";
import {
  success,
  error,
  info,
} from "../../../../../store/notification/actions";

export async function ScanCaptureGoods(data) {
  info("Scanning Capture Goods ...");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/scanCaptureGoods", {
        user_id: data.user_id,
        store_id: data.store_id,
        tote_number: data.tote_number,
        supplier: data.supplier,
        supplier_id: data.selectedSupplier.id,
        load_date: data.load_date,
        barcode: data.barcode,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Capture Goods Scan Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return err.response.data;
      });
  } else {
    error("Internal error occurred");
  }
}

export async function DeleteCaptureGoods(data) {
  info("Deleting Capture Goods ...");
  if (data) {
    return await axiosInstance
      .post("/inventory/deleteCaptureGoods", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
        lot: data.lot,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("Capture Goods deleted Successfully");
          if (response.data.data && response.data.data.length > 0) {
            return response.data.data;
          } else {
            return [];
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

export async function DeleteInventoryStage(data) {
  if (data) {
    return await axiosInstance
      .post("/inventory/deleteInventoryStage", {
        user_id: data.user_id,
        store_id: data.store_id,
      })
      .then((response) => {
        if (response.data.status === "success") {
          success("New session created Successfully");
          if (response.data.data && response.data.data.length > 0) {
            return response.data.data;
          } else {
            return [];
          }
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

export async function SubmitCaptureGoods(data) {
  info("Submiting Capture Goods ...");
  if (data != null) {
    if (!data.tote_number) {
      error("Tote Number can't be empty");
    }
    if (!data.supplier) {
      error("Supplier can't be empty");
    }
    return await axiosInstance
      .post("/inventory/submitCaptureGoods", {
        user_id: data.user_id,
        store_id: data.store_id,
        tote_number: data.tote_number,
        supplier: data.supplier,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Capture Goods Submited Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

export async function CalculateUpcFromBarcode(barcode) {
  return await axiosInstance
    .post("/inventory/calculateUpcFromBarcode", {
      barcode: barcode,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data[0].upc;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function GetUpcDetailsFromBarcode(data) {
  info("Loading upc details ...");
  return await axiosInstance
    .post("/inventory/getUpcDetailsFromBarcode", {
      user_id: data.user_id,
      store_id: data.store_id,
      barcode: data.barcode,
    })
    .then((response) => {
      if (
        response &&
        response.data &&
        response.data.data.length &&
        response.data.status === "success"
      ) {
        success("Upc details fetched successfully !!!");
        return response.data.data[0];
      } else {
        error("No details found !!!");
        return undefined;
      }
    })
    .catch((err) => {});
}

export async function GetCaptureGoods(user_id, store_id) {
  return await axiosInstance
    .post("/inventory/getCaptureGoods", {
      user_id: user_id,
      store_id: store_id,
    })
    .then((response) => {
      if (response && response.data && response.data.status === "success") {
        return response.data.data;
      } else {
        return "";
      }
    })
    .catch((err) => {});
}

export async function UpdateStageInventory(data) {
  info("Update Capture Goods ...");
  if (data != null) {
    if (!data.tote_number) {
      error("Tote Number can't be empty");
    }
    if (!data.supplier) {
      error("Supplier can't be empty");
    }
    return await axiosInstance
      .post("/inventory/updateStageInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        tote_number: data.tote_number,
        supplier: data.supplier,
        supplier_id: data.selectedSupplier.id,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Capture Goods Updated Successfully");
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

// Update comments against ndc in inventory stage table
export async function UpdateCommentsStageInventory(data) {
  info("Updating Comments...");
  if (data != null) {
    if (!data.comment) {
      error("Comment should not be empty");
      return;
    }
    return await axiosInstance
      .post("/inventory/updateCommentsStageInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
        comment: data.comment,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success(response.data.data[0].message);
          return response.data.data;
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}

export async function GetCommentsStageInventory(data) {
  info("Loading Comment..");
  if (data != null) {
    return await axiosInstance
      .post("/inventory/getCommentsStageInventory", {
        user_id: data.user_id,
        store_id: data.store_id,
        ndc: data.ndc,
      })
      .then((response) => {
        if (response.data.data.length > 0) {
          success("Loaded Comments");
          return response.data.data;
        } else {
          success("No comments Found. Add New");
        }
      })
      .catch((err) => {
        error(err.response.data.error[0].message);
      });
  } else {
    error("Internal error occurred");
  }
}
